import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: 'syhqds2022',
	routes: [
		{
			path: '/',
			redirect: '/upload'
		},
		{
			path: '/upload',
			name: 'upload',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "upload" */ './views/Upload.vue')
		},
		{
			path: '/picCase',
			name: 'PicCase',
			meta: {
				hasFooter: false
			},
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "PicCase" */ './views/PicCase.vue')
		},
		{
			//type: 0 相机赛区 1 手机赛区
			path: '/works/:type',
			meta: {
				hasFooter: false
			},
			name: 'WorksWrap',
			component: () => import(/* webpackChunkName: "WorksWrap" */ './views/works/WorksWrap.vue'),
			children: [
				{
					path: '',
					meta: {
						hasFooter: false
					},
					name: 'WorksList',
					component: () => import(/* webpackChunkName: "WorksList" */ './views/works/WorksList.vue')
				},
				{
					path: ':id',
					meta: {
						hasFooter: false
					},
					name: 'WorksDetails',
					component: () => import(/* webpackChunkName: "WorksDetails" */ './views/works/WorksDetails.vue')
				}
			]
		},
		{
			path: '/wxAuth',
			name: 'WxAuth',
			meta: {
				hasFooter: false
			},
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "PicCase" */ './views/WxAuth.vue')
		},
		{
			path: '/scan',
			name: 'Scan',
			meta: {
				hasFooter: false
			},
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "PicCase" */ './components/upload/ScanWrapper.vue')
		},
		{
			path: '*', // 此处需特别注意至于最底部
			redirect: '/upload'
		}
	]
});

router.beforeEach((to, from, next) => {
	/* 监听全局前置守卫，文档：https://router.vuejs.org/zh/guide/advanced/navigation-guards.html#全局前置守卫 */
	if (to.path) {
		/* 即将要进入的目标 路由对象 */
		if (_hmt) {
			/* 如果有全局的_hmt */
			_hmt.push([
				'_trackPageview',
				'/#' + to.fullPath
			]); /* 发送要进入页面的完整url的PV统计请求，文档地址：https://tongji.baidu.com/web/help/article?id=235&type=0&from_query=trackPageview&index=0 */
			// console.log('to=', to, ';_hmt=', _hmt); /* 日志信息，页面跳转时控制台可查看，发布时请删除此行日志 */
		}
	}
	next(); /* 进行管道中的下一个钩子。必须存在，否则页面无法正常跳转！ */
});

export default router;
